import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import './ck-editor.css';

export default function CustomMarkdown({ children }) {
	const options = {
		replace: ({ attribs, children }) => {
			if (!attribs) {
				return;
			}
			if (attribs.href) {
				// overwrite the a tag to open links in a new tab
				return (
					<a
						{...attribs}
						onClick={() =>
							window.analytics.track('Link Clicked', {
								link_name: children[0].data
									? children[0].data
									: children[0].children[0].data,
								link: attribs.href,
								path: window.location.pathname,
								url: window.location.href,
							})
						}
						// target='_blank' rel='noopener noreferrer'
					>
						{domToReact(children, options)}
					</a>
				);
			}
		},
	};
	return <div className='ck-content'>{parse(children, options)}</div>;
}
